import { render } from "./Sent.vue?vue&type=template&id=2c5f6dc6"
import script from "./Sent.vue?vue&type=script&lang=js"
export * from "./Sent.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__